export default __webpack_public_path__ + "static/media/Cat_O_Mats_and_Runners_V2.0eff5dd6.jpeg";